import { WebsiteStatesService } from '../../website-states.service';
var ResponsiveStateService = /** @class */ (function () {
    function ResponsiveStateService(website) {
        this.website = website;
    }
    Object.defineProperty(ResponsiveStateService.prototype, "responsiveWidths", {
        // noinspection JSMethodCanBeStatic
        get: function () {
            return (window.responsiveWidths && responsiveWidths || []).sort(function (a, b) { return a - b; });
        },
        enumerable: true,
        configurable: true
    });
    ResponsiveStateService.prototype.getWidth = function (forElement) {
        var _this = this;
        return this.website.windowResize.map(function () {
            var width = forElement.clientWidth;
            if (_this.responsiveWidths.length === 0) {
                return 0;
            }
            var smallestWidth = _this.responsiveWidths[0];
            if (width <= smallestWidth) {
                return smallestWidth;
            }
            // Return next width after width
            return _this.responsiveWidths.filter(function (w) { return w > width; })[0];
        });
    };
    return ResponsiveStateService;
}());
export { ResponsiveStateService };
